var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default"),_c('div',{staticClass:"block my-table"},[_c('el-pagination',{staticClass:"pagination z-depth-1",attrs:{"layout":_vm.calcLayout(),"total":_vm.total,"current-page":_vm.pageNum+1,"page-size":_vm.pageSize},on:{"current-change":_vm.changePage}})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }